import React from "react";
import { NavLink } from "react-router-dom";
import "./Sidebar.scss";
import dashboard from '../../assets/images/sidebar/dashboard.svg';
import appointment from '../../assets/images/sidebar/appointment.png';
import logout from '../../assets/images/logout.png';
import support from '../../assets/images/sidebar/support.svg';
import report from '../../assets/images/sidebar/report.svg';
import ticket from '../../assets/images/sidebar/ticket.svg';
import { useNavigate, Link } from "react-router-dom";
import { handleConfirmation } from "../../utils/confirm";
import hestailogo from "../../assets/transp.png";

const ClientSidebar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    handleConfirmation(() => {
      navigate("/logout");
    }, () => {
      return false
    })
  };

  return (
    <div className="sidebar">
      <div className="sidebar-inner">
        <div className="logo">
          <img src={hestailogo} className="sidebar-logo"/>
        </div>
        <div className="module-name">
          Client Portal
        </div>
        <div className="menu-links">
          <ul>
            <li>
              <NavLink  className={({ isActive }) => isActive? "active": ''}  to='/clinic/dashboard'>
                <img src={dashboard} />
                <span>Dashboard</span>
              </NavLink>
            </li>
            {/* <li>
              <NavLink  className={({ isActive }) => isActive? "active": ''}  to='/clinic/appointment/list'>
                <img className='appointment' src={appointment} />
                <span>Calendar</span>
              </NavLink>
            </li> */}
            {/* <li>
              <NavLink className={({ isActive }) => isActive? "active": ''} to='/clinic/patient/list'>
                <img src={support} />
                <span>Patient List</span>
              </NavLink>
            </li> */}
            <li>
              <NavLink className={({ isActive }) => isActive? "active": ''} to='/clinic/ticket/list'>
                <img src={ticket} />
                <span>Ticket Management</span>
              </NavLink>
            </li>
            <li>
              <NavLink className={({ isActive }) => isActive? "active": ''} to='/clinic/reports'>
                <img src={report} />
                <span>Reports</span>
              </NavLink>
            </li>
            <li>
              <Link className={({ isActive }) => isActive? "active": ''} onClick={handleLogout}>
                <img src={logout} />
                <span>Logout</span>
              </Link>
            </li>
          </ul>
          <div className="bottom-text">
            <p>© Liaise. All Rights Reserved. V.0.0.1</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientSidebar;



